import { Button, Image, Typography } from "@version2/ui-package";
import React, { Suspense, lazy } from "react";
import { pages } from "src/Consts/config";
import icon from "../../Assets/Images/icon.png";
import FullScreenView from "../../Components/Shared/Screen/FullScreen/FullScreen";
import HomeBackgroundFallback from "./HomeBackgroundFallback";
import { trackCtaClick } from "src/Services/firebase/analytics";
import SEO from "../../Components/SEO/SEO";
import { pageSEO } from "../../Components/SEO/seoConfig";

const HomeBackground = lazy(() => import("./HomeBackground"));

const { Title } = Typography;

const HomeView = () => {
  return (
    <>
      <SEO {...pageSEO.home} />
      <FullScreenView>
        <Suspense fallback={<HomeBackgroundFallback />}>
          <HomeBackground />
        </Suspense>
        <div
          style={{
            zIndex: 1,
            position: "relative",
            backgroundColor: "#ffffff40",
            backdropFilter: "blur(3px)",
            border: "1px solid #eeeeee",
            padding: "24px",
            borderRadius: "8px",
          }}
        >
          <Image
            src={icon}
            width="96px"
            height="96px"
            preview={false}
            alt="Version2 logomark featuring interlocking gradient cubes"
          />
          <Title level={1}>Powerful add-ons to the services you love</Title>
          <p>
            Version2 provides a collection of add-ons to services and tools you
            already use: extensions, themes, scripts, and other tools that rocket
            the services you already know and love to the next level.
          </p>
          <div style={{ marginBottom: "24px" }} />
          <Button
            href={pages.EXPLORE_ADD_ONS_PAGE.url}
            type="primary"
            block
            onClick={() => {
              void trackCtaClick("home_explore_add_ons", {
                destination: pages.EXPLORE_ADD_ONS_PAGE.url,
              });
            }}
          >
            Explore add-ons
          </Button>
        </div>
      </FullScreenView>
    </>
  );
};

export default HomeView;
